/**
 * @title application.js: Feature level module
 * @description The interface for membership application. These methods
 *              are bound in /MembershipApplicationView
 *              (NewMembershipApplicationBody.jsp) and use applicationForm
 *              for primary membership interaction and applicationAffiliateForm
 *              for affiliate interaction.
 */
define(['applicationForm', 'applicationAffiliateForm', 'membershipHelper'], function(appForm, affForm, helper) {
  let Application = {
    /**
     * Initialize the application specific functions
     * @return {void}
     */
    init: function() {
      helper.init();
      appForm.init();
      affForm.init();
      this.applicationPreprocesses();
    },
    /**
     * This process is responsible for grabbing application meta
     * data (configProduct) and setting inputs and then populating
     * any affiliates that exist.
     * @return {void}
     */
    applicationPreprocesses: function() {
      helper.getApplicationData()
        .then(helper.prepopulateForm)
        .then(helper.reflectAffiliates)
        .fail((err) => {
          let message = 'Couldn\'t fetch membership application data';
          console.error(`${message} ${JSON.stringify(err.errorMessages, null, 2)}`);
          let appType = $('#applicationType').val();        
          if (appType === 'BD'){
        	  window.location.href = '/CheckoutCartView';
          }
        });
    },
    /**
     * Main function and inline event hanlder for "Submit and Continue"
     * for adding personal inforamtion / businss inforamtion to the
     * application.
     * @return {void} [description]
     */
    addMember: function() {
      if (appForm.validate()) {
        // Pages using this: QuickMembershipApplicationBody.jsp,
        $('.permanent-ajax-busy').addClass('ajax-busy');
        helper
          // Attempt to call address verification service
          .verifyAddresses({
            form: '#MemberAddressBookForm',
            primary: helper.personalAddressSelectors,
            business: helper.businessAddressSelectors,
          })
          // If the service returns successfully (200), invoke the modal
          // and use the addresses the user selects
          .then((verifyResponse) =>
            helper.invokeMultiAVS(verifyResponse, appForm.submitContinue))
          // If the service fails, we still want to submit the form using
          // the addresses the user provided initially
          .fail(appForm.submitContinue);
      }
    },
    /**
     * 
     */
    cancelMemberApplication: function() {
    	if(document.referrer === "") {
    		window.location.href = '/CheckoutCartView';
    	} else if (document.referrer.includes('/QuickMembershipTermsConditionsView')){
    		window.location.href = '/join-costco.html';
    	} else {
        window.location.href = DOMPurify.sanitize(document.referrer);
      }
    },
    /**
     * This is the main function (and inline event handler) for
     * adding a person (affiliate) to the membership application.
     * This functionality has a dependency on the personal / business
     * info being submitted first.
     * @return {void} [description]
     */
    addPerson: function() {
      let configProduct = helper.getConfigProduct();
      // 1. Click "Add Person"
      // If configproduct is empty or configProduct.type is empty or undefined
      // Proceed to 2. Else Proceed to 5
      if ($.isEmptyObject(configProduct) || !configProduct.type) {
        $('.permanent-ajax-busy').addClass('ajax-busy');
        // 2. Validate the personal information, business information, and
        //  household (if entered).
        if (appForm.validate()) {
          helper
            // 3. If validated, execute address verification on the personal and
            //  business addresses. (/AjaxAddressVerificationCmd)
            .verifyAddresses({
              form: '#MemberAddressBookForm',
              primary: helper.personalAddressSelectors,
              business: helper.businessAddressSelectors,
            })
            // 4. If the service returns successfully (200), invoke the modal
            // and use the addresses the user selects
            .then((verifyResponse) =>
              helper.invokeMultiAVS(verifyResponse, appForm.submitInvokeAddPersonModal))
            // 5. If the service fails, we still want to submit the form using
            // the addresses the user provided initially and then open the
            // add person modal
            .fail(appForm.submitInvokeAddPersonModal);
        }
      } else {
        // 5. Invoke the Add Person Modal (limit 6 additional people)
    	  affForm.openAddPersonModal();
    	  }
      $('.permanent-ajax-busy').removeClass('ajax-busy');
    },
    /**
     * Remove a person (affiliate) from the membership application
     * @param  {Number} membershipNumber The affiliate membership number
     * @return {void}
     */
    removePerson: function(membershipNumber) {
      let affiliate = helper.getAffiliateByNumber(membershipNumber);
      affForm.removePerson({
        affiliate: affiliate,
        action: 'remove',
      });
    },
    /**
     * Remove a person's (affiliate) household from the membership applciation
     * @param  {Number} membershipNumber The affiliate household membership num
     * @return {void}
     */
    removePersonHousehold: function(membershipNumber) {
      let affiliate = helper.getAffiliateByHouseholdNumber(membershipNumber);
      affForm.removePerson({
        affiliate: affiliate,
        action: 'remove-household',
      });
    },
    /**
     * Edit a person (affiliate) from the membership application
     * @param  {Number} membershipNumber The affiliate membership number
     * @return {void}
     */
    editPerson: function(membershipNumber) {
      let affiliate = helper.getAffiliateByNumber(membershipNumber);
      affForm.editPerson({
        affiliate: affiliate,
        action: 'update',
      });
    },
    /**
     * "Adding a person within household" is really a variation on editing the
     * affiliate and selecting the checkbox that shows the household fields.
     * @param  {Number} membershipNumber The Affiliate membershipNumber
     * @return {void}
     */
    addPersonWithinHousehold: function(membershipNumber) {
      let affiliate = helper.getAffiliateByNumber(membershipNumber);
      affForm.editPerson({
        affiliate: affiliate,
        action: 'update',
        addHousehold: true,
      });
    },
    /**
     * "Editing a person within household" is really a variation on editing the
     * affiliate and selecting the checkbox that shows the household fields.
     * @param  {Number} membershipNumber The Affiliate membershipNumber
     * @return {void}
     */
    editPersonWithinHousehold: function(membershipNumber) {
      let affiliate = helper.getAffiliateByNumber(membershipNumber);
      affForm.editPerson({
        affiliate: affiliate,
        action: 'update',
        editHousehold: true,
      });
    },
  };
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.Application = Application;
  return Application;
});



// WEBPACK FOOTER //
// ./js/membership/application.js